export default __webpack_public_path__ + "static/media/Gloves of the Doomsayer.62098c64.jpg";